import QprThemeProvider from '@qpr/theme';
import React from 'react';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import BMCPage from './pages/BMC';
import CanvasLayoutPage from './pages/CanvasLayout';
import CBCPage from './pages/CBC';
import DashboardPage from './pages/Dashboard';
import GroupedKpiList from './pages/GroupedKpiListPage';
import IntermediatePage from './pages/IntermediatePage';
import KpiAimView from './pages/KPIAimView';
import KpiList from './pages/KpiListPage';
import LandingPage2 from './pages/LandingPage2';
import MapPage from './pages/MapPage';
import MapPage2 from './pages/MapPage2';
import MeasuresPage from './pages/MeasuresPage';
import PageNotFound from './pages/PageNotFound';
import ProcessIntegrationPage from './pages/ProcessIntegrationPage';
import RoleBrowser from './pages/RoleBrowser';
import RootPage from './pages/Root';
import SIPOCPage from './pages/SIPOC';
import Strategy from './pages/Strategy';

const Routes = () => {
  const { path } = useRouteMatch();
  return (
    <Switch>
      <Route path={`${path}/landingpage2`} component={LandingPage2} />
      <Route path={`${path}/`} component={RootPage} exact />
      <Route>
        <QprThemeProvider themeName="default-theme">
          <Switch>
            <Route path={`${path}/canvas/:containerId/`} component={CanvasLayoutPage} />
            <Route path={`${path}/maps/:containerId/`} component={MapPage} />
            <Route path={`${path}/maps2/:containerId/`} component={MapPage2} />
            <Route path={`${path}/operations/maps/processes/:containerId`} component={MapPage} />
            <Route path={`${path}/operations/`} component={IntermediatePage} />
            <Route path={`${path}/value/`} component={IntermediatePage} />
            <Route path={`${path}/bmc/:corporateId/`} component={BMCPage} />
            <Route path={`${path}/sipoc/:businessProcessId/:sipocId?/`} component={SIPOCPage} />
            <Route path={`${path}/cbc/:rootElementId/`} component={CBCPage} />
            <Route path={`${path}/e2e/:e2eProcessId?/`} component={ProcessIntegrationPage} />
            <Route path={`${path}/dashboard/`} component={DashboardPage} />
            <Route path={`${path}/strategy/:meaId/`} component={Strategy} />
            <Route path={`${path}/measures/:meaId/`} component={MeasuresPage} />
            <Route path={`${path}/kpilist/:meaId/`} component={KpiList} />
            <Route path={`${path}/kpiaim/:meaId/`} component={KpiAimView} />
            <Route path={`${path}/groupedkpilist/:meaId/`} component={GroupedKpiList} />
            <Route path={`${path}/rolebrowser/:meaId/`} component={RoleBrowser} />
            <Route component={PageNotFound} />
          </Switch>
        </QprThemeProvider>
      </Route>
    </Switch>
  );
};

export default Routes;
